import PosaTemplate from './PosaTemplate';
import PropTypes from 'prop-types';
import React from 'react';
import {SlickWrapper} from 'epic-react-common';
import StepsSliderStyled from './StepsSliderStyled';

const StepsSlider = ({data}) => {
  const {slide, subtitle, title} = data;
  if (!slide || !slide.length) return null;
  const options = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
  };
  const carouselItems = slide.map(({image, tips}, index) => {
    return (
      <li key={index}>
        <img src={image} alt={`step-${index}`} />
        <PosaTemplate Tag="div" isTemplate string={tips} />
      </li>
    );
  });
  return (
    <StepsSliderStyled className="ecr-steps-slider">
      <div className="ecr-slider-wrapper">
        {title ? <h1>{title}</h1> : null}
        {subtitle ? <h3>{subtitle}</h3> : null}
        <SlickWrapper options={options}>{carouselItems}</SlickWrapper>
      </div>
    </StepsSliderStyled>
  );
};

StepsSlider.propTypes = {
  data: PropTypes.object,
};

export default StepsSlider;
